import ProtectedContent from './ProtectedContent';

export default ProtectedContent;
